import { render, staticRenderFns } from "./AwardsTable.vue?vue&type=template&id=3c6f8927&scoped=true"
import script from "./AwardsTable.vue?vue&type=script&lang=js"
export * from "./AwardsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f8927",
  null
  
)

export default component.exports